import { render, staticRenderFns } from "./PortfolioBuilder.vue?vue&type=template&id=fc182328&scoped=true&"
import script from "./PortfolioBuilder.vue?vue&type=script&lang=js&"
export * from "./PortfolioBuilder.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioBuilder.vue?vue&type=style&index=0&id=fc182328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc182328",
  null
  
)

export default component.exports